var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{class:['c_menu', { 'new-menu': _vm.isNewStyle }]},[_c('ul',_vm._l((_vm.navLIst),function(item){return _c('li',{key:item.key,class:_vm.current == item.key ? 'cur' : ''},[(item.key != 'release')?[_c('router-link',{attrs:{"to":item.path}},[_c('i',{class:['iconfont', item.icon]}),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.name))])])]:[_c('a',{attrs:{"href":'https://static.xubei.com/act/download0418/' +
						_vm.download +
						'?source=h5&channel=' +
						_vm.channel +
						'&f=' +
						_vm.fChannel +
						'&userId=' +
						_vm.userId},on:{"click":_vm.appLoad}},[_c('i',{staticClass:"iconfont"},[_vm._v("")]),_vm._v(" "),_c('span',[_vm._v("APP下载")])])]],2)}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b056019","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/menu/menu.vue
// module id = null
// module chunks = 